import { FC } from "react";
import { Button, Modal, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { formatWithCommas } from "components/ManageProduct/CreateProduct/ProductSKUCreate/helpers";

const { Paragraph } = Typography;

type Props = {
  open: boolean;
  onClose: () => void;
  /** ราคาค่าขนส่งดิบของพัสดุที่ทำให้เครดิตไม่พอ — ไม่ระบุถ้าเป็นการเช็คเครดิตขั้นต่ำทั่วไป (ไม่ผูกกับพัสดุใบใดใบหนึ่ง) */
  estimatePrice?: number | null;
  /** multiplier ปัจจุบัน — ใช้แค่แสดง "เครดิตที่ใช้" ให้ตรงกับโควต้าจริงที่โรงงานเห็น */
  multiplier?: number;
};

const InsufficientCreditModal: FC<Props> = ({ open, onClose, estimatePrice, multiplier = 2 }) => {
  const navigate = useNavigate();
  const hasPrice = estimatePrice != null && estimatePrice > 0;

  return (
    <Modal
      open={open}
      title="เครดิตไม่เพียงพอ"
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          ปิด
        </Button>,
        // 2026-09-01: เดิมให้โทรหาเจ้าหน้าที่เติมให้เท่านั้น — ตอนนี้เติมเองผ่าน gateway ได้ทันทีจากหน้านี้
        <Button
          key="topup"
          type="primary"
          onClick={() => {
            onClose();
            navigate("/manage-credit/topup");
          }}
        >
          เติมเครดิต
        </Button>,
      ]}
      centered
    >
      <Paragraph>
        เครดิตคงเหลือของท่านไม่เพียงพอสำหรับการสร้างพัสดุ
      </Paragraph>
      {hasPrice && (
        <>
          <Paragraph style={{ marginBottom: 4 }}>
            ราคาค่าขนส่ง: <Typography.Text strong>{formatWithCommas(Math.ceil(estimatePrice))} บาท</Typography.Text>
          </Paragraph>
          <Paragraph>
            เครดิตที่ใช้:{" "}
            <Typography.Text strong style={{ color: "#ff4d4f" }}>
              {formatWithCommas(Math.ceil(estimatePrice * multiplier))} เครดิต
            </Typography.Text>
          </Paragraph>
        </>
      )}
      <Paragraph>
        กดปุ่ม "เติมเครดิต" ด้านล่างเพื่อเติมเองผ่านช่องทางชำระเงิน หรือติดต่อเจ้าหน้าที่ (คุณจอย) ที่เบอร์โทรศัพท์{" "}
        <Typography.Text strong>0868263999</Typography.Text>
      </Paragraph>
    </Modal>
  );
};

export default InsufficientCreditModal;
